import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormConditionProperty, {
  MxFormMxFormConditionPropertyPropertyProps
} from "@rf-l2/form/select/MxFormConditionProperty";

export interface MxFormL3SelectConditionPropertyProps
  extends MxFormMxFormConditionPropertyPropertyProps {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3ConditionStatusPropertyField = (
  props: MxFormL3SelectConditionPropertyProps
) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormConditionProperty {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3ConditionStatusPropertyField;
